import service from "@/utils/request";
// 获取代理人列表
export function getdlrlistApi(data) {
  return service.post(`pcuser/daililist`, data);
}
//添加代理人
export function adddlrlistApi(data) {
  return service.post(`pcuser/adddaili`, data);
}
//修改代理人
export function editdlrlistApi(data) {
  return service.post(`pcuser/editdaili`, data);
}

// 删除代理人
export function deldlrlistApi(data) {
  return service.post(`pcuser/dailidel`, data);
}
// 获取代理人详情数据
export function dailidetailApi(data) {
  return service.post(`pcuser/dailidetail`, data);
}

// 代理数据导出
export function dailiexportApi() {
  return service.post(`export/userexport`);
}


// 获取代理人合同列表
export function getddailicontractlistApi(data) {
  return service.post(`pcuser/dailicontractlist`, data);
}
// 添加代理人合同
export function adddailicontractApi(data) {
  return service.post(`pcuser/adddailicontract`, data);
}

// 代理人合同详情
export function dailicontractdetailApi(id) {
  return service.post(`pcuser/dailicontractdetail`, { id: id });
}
// 修改代理人合同
export function editdailicontractApi(data) {
  return service.post(`pcuser/editdailicontract`, data);
}

// 删除代理人合同
export function deldailicontractApi(data) {
  return service.post(`pcuser/deldailicontract`, data);
}

// 导出代理人合同
export function exportdailicontractApi(data) {
  return service.post(`export/contractexport`, data);
}
